function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import KeenSlider, { TOptionsEvents } from 'keen-slider';
var CAROUSEL_DEFAULTS = {
  autoplay: false,
  autoplaySpeed: 10
};
var CLASS_ACTIVE = 'is-active';
var SEL_DOT = '[data-carousel-dot]';
var CUSTOM_ACTIVE_CLASS = 'is-active-tab';
var CUSTOM_ACTIVE_CLASS_FAMILY = 'is-active-family';
export var initCarousel = function initCarousel(container, options, dotsContainers, prevButton, nextButton, customInitialSlide, progressBar, onMountedCallback) {
  options = _objectSpread(_objectSpread({}, CAROUSEL_DEFAULTS), options);
  var slides = [];
  var slider;
  container.classList.add('keen-slider');
  container.childNodes.forEach(function (child) {
    if (_typeof(child.classList) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) return;
    var element = child;
    element.classList.add('keen-slider__slide');
    slides.push(element);
  }); //Autoplay

  var autoplayTimeout;
  var autoplayState;

  var autoplay = function autoplay(state) {
    var newState = !!state;
    autoplayState = newState;
    if (!state) return clearTimeout(autoplayTimeout);
    autoplayTimeout = setTimeout(function () {
      if (!autoplayState) return;
      autoplay(autoplayState);
      slider.next();
    }, (options.autoplaySpeed || 10) * 1000);
  };

  autoplay(options.autoplay); // Update active class

  var updateClasses = function updateClasses(slider) {
    var slide = slides[slider.details().relativeSlide];
    var visibleSlides = Math.floor(slider.details().slidesPerView);
    var slideId = slides.indexOf(slide);
    slides.forEach(function (slide) {
      return slide.classList.remove(CLASS_ACTIVE);
    });

    try {
      slide.classList.add(CLASS_ACTIVE); // Set active status to slides that are fully in view
      // on Our Story family courasel section

      if (slide.hasAttribute('data-family-tile')) {
        // Set active class to fully visible slides
        slides.forEach(function (slide) {
          return slide.classList.remove(CUSTOM_ACTIVE_CLASS_FAMILY);
        });

        switch (visibleSlides) {
          case 2:
            slide.classList.add(CUSTOM_ACTIVE_CLASS_FAMILY);
            if (slides[slideId + 1]) slides[slideId + 1].classList.add(CUSTOM_ACTIVE_CLASS_FAMILY); // If last slide, set first slide to active

            if (slideId === slides.length - 1) {
              slides[0].classList.add(CUSTOM_ACTIVE_CLASS_FAMILY);
            }

            break;

          case 3:
            slide.classList.add(CUSTOM_ACTIVE_CLASS_FAMILY); // If two or more slides left, set them to active

            if (slides[slideId + 1]) {
              slides[slideId + 1].classList.add(CUSTOM_ACTIVE_CLASS_FAMILY);

              if (slides[slideId + 2]) {
                slides[slideId + 2].classList.add(CUSTOM_ACTIVE_CLASS_FAMILY);
              }
            } // If second to last slide, set first slide to active


            if (slideId === slides.length - 2) {
              slides[0].classList.add(CUSTOM_ACTIVE_CLASS_FAMILY);
            } // If last slide, set first and second slide to active


            if (slideId === slides.length - 1) {
              slides[0].classList.add(CUSTOM_ACTIVE_CLASS_FAMILY);
              slides[1].classList.add(CUSTOM_ACTIVE_CLASS_FAMILY);
            }

            break;

          default:
            break;
        }
      }
    } catch (error) {
      console.error(error);
    }

    var slideIndex = slider.details().relativeSlide;

    if (dotsContainers) {
      dotsContainers.forEach(function (dotsContainer) {
        var dots = dotsContainer.querySelectorAll(SEL_DOT);
        if (!dots) return;
        dots.forEach(function (dot, idx) {
          // move to slide on dot click
          dot.addEventListener("click", function () {
            slider.moveToSlide(idx);
          });

          if (idx === slideIndex) {
            dot.classList.add(CLASS_ACTIVE);
            dot.classList.add("dot--active");
            return;
          }

          dot.classList.remove(CLASS_ACTIVE);
          dot.classList.remove("dot--active");
        });
      });
    } //update progress bar


    if (progressBar) {
      var details = slider.details();
      var fraction = 100 / details.size;
      var currentProgress = fraction * details.relativeSlide + fraction;
      progressBar.style.width = "".concat(currentProgress, "%");
    }
  }; // On destroyed callback


  var onDestroyed = function onDestroyed() {
    slides.forEach(function (slide) {
      slide.classList.remove(CLASS_ACTIVE);
      slide.removeAttribute('style');
    });
  };

  var _mounted = function mounted(slider) {
    if (customInitialSlide) {
      slides.forEach(function (slide, index) {
        if (slide.classList.contains(CUSTOM_ACTIVE_CLASS)) {
          slider.moveToSlide(index);
        }
      });
    }

    if (onMountedCallback) {
      onMountedCallback(options, slider);
    }
  };

  container.addEventListener("mouseover", function () {
    autoplay(false);
  });
  container.addEventListener("mouseout", function () {
    autoplay(options.autoplay);
  });

  if (prevButton) {
    prevButton.addEventListener("click", function () {
      slider.prev();
    });
  }

  if (nextButton) {
    nextButton.addEventListener("click", function () {
      slider.next();
    });
  }

  var customSlidesPerView = function customSlidesPerView(slider) {
    /*
      does't work for breakpoints sliderPerView
      if breakpoint >= 750 skips the calculation
      TO DO add breakpoints handeling
    */
    var slidesPerView = Number(options['slidesPerView']);
    var windowWidth = window.innerWidth;
    if (slidesPerView >= 1 || windowWidth >= 750) return;
    var slideWidth = 1 / slidesPerView * 100;

    for (var i = 0; i < slides.length; i++) {
      slides[i].style.minWidth = "".concat(slideWidth, "%");
      slides[i].style.maxWidth = "".concat(slideWidth, "%");
    }
  }; // On slide moved


  var onSlideMoved = function onSlideMoved(slider) {
    var slidesPerView = Number(options['slidesPerView']);
    if (!slidesPerView) return;
    if (slidesPerView < 1) customSlidesPerView(slider);
  }; //Slider Init


  slider = new KeenSlider(container, _objectSpread(_objectSpread({}, options), {}, {
    dragStart: function dragStart() {
      return autoplay(false);
    },
    dragEnd: function dragEnd() {
      return autoplay(options.autoplay);
    },
    slideChanged: function slideChanged(slider) {
      return typeof options.slideChanged === 'function' ? options.slideChanged(slider) : updateClasses(slider);
    },
    move: function move(slider) {
      return typeof options.move === 'function' ? options.move(slider) : onSlideMoved(slider);
    },
    destroyed: function destroyed() {
      return onDestroyed();
    },
    mounted: function mounted(slider) {
      return typeof options.mounted === 'function' ? options.mounted(slider) : _mounted(slider);
    }
  }));
  requestAnimationFrame(function () {
    return requestAnimationFrame(function () {
      updateClasses(slider);
    });
  });
  return {
    slider: slider,
    autoplay: autoplay,
    slides: slides
  };
};